<template>
  <div class="comprehensive-analysis">
    <gj-analysis-panel
        :title="'综合分析'"
    >
      <template #subtitle>
        <span class="left-option-header-time">
          {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}
        </span>
      </template>
      <template #rightContainer>
        <OptionGroup
            :help="true"
            @refresh="refresh"
            @download="download"
            @openCustomColumnModal="openCustomColumnModal"
        />
      </template>
      <template #panelBody>
        <OptionPanelGroup
            :loading="loadingLeft"
            :currentSelect="currentSelect"
            :showHelp="true"
            :number-color="comprehensiveAnalysisDetailVO.trafficError?'#F5222D':null"
            :data="optionData"
            @openSetting="openCustomColumnModal"
            @update:currentSelect="selectOption"
        />
        <div class="comprehensive-analysis-content">
          <el-row :gutter="10">
            <el-col :span="10">
              <div class="title-group">
                <div>{{settingMap[chartfilter.activeOption]}}</div>
                <div v-if="symbolAll.prefix.includes(chartfilter.activeOption)">
                  {{ comprehensiveAnalysisDetailVO[chartfilter.activeOption] | amount | defaultShow(comprehensiveAnalysisDetailVO.currencySymbol) }}
                </div>
                <div v-else-if="symbolAll.suffix.includes(chartfilter.activeOption)">
                  {{ comprehensiveAnalysisDetailVO[chartfilter.activeOption] || 0}}%
                </div>
                <div v-else>{{ comprehensiveAnalysisDetailVO[chartfilter.activeOption] }}</div>
              </div>
              <el-card class="box-card" v-loading="loadingLeft">
                <Chart :type="'bar'" :option="comprehensiveAnalysisPieOption" :empty="emptyPieData"/>
              </el-card>
            </el-col>
            <el-col :span="14">
              <el-card class="box-card" style="overflow: visible;" v-loading="loadingRight">
                <gj-select
                    v-model="chartfilter.comparisonMethod"
                    :options="option.comparisonMethodOptions"
                    :clearable="false"
                    @input="changeComparisonMethod"
                >
                </gj-select>
                <gj-select
                    v-if="isShowComparisonMethodSelect"
                    v-model="chartfilter.indexComparisonActives"
                    :options="chartfilter.dateType === 'HOURS' ? option.hourIndexComparisonOption : option.indexComparisonOptions"
                    @input="changeIndexComparisonOptions"
                    :clearable="false"
                    :width="'200px'"
                    :type="'multi-check'"
                >
                </gj-select>
                <gj-radio-group
                    v-model="chartfilter.dateType"
                    :options="option.dateType"
                    @input="debouncchangeDateType"
                >
                </gj-radio-group>
                <Chart ref="chart" :type="'bar'" :option="comprehensiveAnalysisLineOption" :style="{height: '268px'}"/>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </template>
    </gj-analysis-panel>
  </div>
</template>

<script>
import _ from "lodash"
import OptionPanelGroup from "@/views/components/option-panel-group/option-panel-group"
import Chart from "@/views/components/chart/chart"
import {comparisonMethodOptions,/* indexComparisonOptions */comparisonOptionsOthers} from "@/utils/options";
import OptionGroup from "@/views/components/option-panel-group/option-group"

import {getOverviewAndPieData,getlineChartData} from "@/api/statistics"
import { settingMap } from "@/utils/setting.js"
import {mapGetters} from "vuex";
import {convertToFullDate, dateShortcut} from "@/utils/date.util";
import {exportFile, getCustomColumns} from "@/api/common";
import { amount } from "@/filters";
import {isMeaningless} from "@/utils/common";

export default {
  name: "comprehensive-analysis",
  components: { OptionPanelGroup, Chart,OptionGroup},
  inject: ['getPageParams'],
  props:{
    countryMarketValue:{
      type: Object
    },
    categoryIds:{
      type: Object
    },
    operationStatus:{
      type: Number
    },
    date: {
      type: Object
    }
  },
  data(){
    return{
      useCache: false,
      numberMinMax: {
        Yleft: { min: 0, max: 0, interval: 10},
        Yright: { min: 0, max: 0, interval: 10},
      },

      loadingLeft: false,   //上部概览和左侧调用同一个接口
      loadingRight: false,
      //设置module 名字
      settingName: "ComprehensiveAnalysis",
      //顶部时间文字
      shortcutText: null,
      //饼图数据
      comprehensiveAnalysisPieOption: {},
      // 折线图数据
      comprehensiveAnalysisLineOption: {},
      //是否显示指标明细下拉框
      isShowComparisonMethodSelect: false,
      //顶部概览数据源
      optionData: [],
      //顶部概览选中项
      currentSelect: { key: "unitsOrdered", label: "销量"},
      //折线图的筛选条件
      chartfilter: {
        comparisonMethod: 0,                     //0 时间对比  1 指标对比
        indexComparison: "unitsOrdered",                      //指标
        dateType: 'DAY',                        //时间刻度   按时 按日 按周 按月
        activeOption: "unitsOrdered",       //概览选项
        indexComparisonActives: ["unitsOrdered"],
      },
      // 下拉框数据源
      option: {
        comparisonMethodOptions: comparisonMethodOptions,
        indexComparisonOptions: comparisonOptionsOthers,
        hourIndexComparisonOption : [
          {id: "unitsOrdered", text: '销量'},
          {id: "orderProductSales", text: '销售额'},
          {id: "orders", text: '订单量'}
        ],
        dateType: [
          {id: 'HOURS', text: '按时'},
          {id: 'DAY', text: '按日'},
          {id: 'WEEK', text: '按周'},
          {id: 'MONTH', text: '按月'},
        ]
      },
      //后端返回的数据存储（本地筛选）
      comprehensiveAnalysisDetailVO: [],
      comprehensiveAnalysisDetailVOThen: [],
      comprehensiveAnalysisPieVO: [],
      statisticsData : [],
      thenData: [],
      //----------end ------------
      //饼图series数据
      pieSeriesData: [],
      //折线图x轴数据
      xAxisLine: [],
      //折线图series数据
      lineSeriesData: [],
      //折线图legend 数据
      lineLegendData: [],
      //是否为空数据，（后端给的数据不足以判断，需要前端通过某个字段判断，不稳固）
      emptyPieData: false,
      emptyLineData: false,
      //module列元数据
      moduleColumns: [
        {label: "销量", key: "unitsOrdered", sortIndex: 0, default: true },
        {label: "销量-B2B", key: "unitsOrderedB2b", sortIndex: 1 },
        {label: "销售额", key: "orderProductSales", prefix: 'currencySymbol',sortIndex: 2, default: true },
        {label: "销售额-B2B", key: "orderProductSalesB2b", prefix: 'currencySymbol',sortIndex: 3 },
        {label: "订单量", key: "orders", sortIndex: 4, default: true},
        {label: "退款量", key: "refunds", sortIndex: 5},
        {label: "退款率", key: "refundsRate", sortIndex: 6 ,suffix: '%'},
        {label: "退款销售额", key: "returnProductSales", prefix: 'currencySymbol',sortIndex: 7 },
        {label: "退货量", key: "returns", sortIndex: 8 },
        {label: "退货率", key: "returnsRate", suffix: '%', sortIndex: 9 },
        // {label: "平均订单商品种类数", key: "avgOrderItems", sortIndex: 10 },              //这个指标暂时隐藏
        {label: "平均订单价格", key: "avgUnitsOrderedSales", prefix: 'currencySymbol',sortIndex: 11 },

        {label:'Sessions-移动端',key:'sessionsMobile',sortIndex:38},
        {label:'Sessions-PC端',key:'sessionsBrowser',sortIndex:39},
        {label:'Sessions-总计',key:'sessions',sortIndex:30},
        {label:'CVR',key:'unitSessionPercentage',suffix: '%',sortIndex:31},
        {label:'PV-移动端',key:'pageViewsMobile',sortIndex:40},
        {label:'PV-PC端',key:'pageViewsBrowser',sortIndex:41},
        {label:'PV-总计',key:'pageViews',sortIndex:32},
        {label:'Buybox',key:'buyBoxPercentage',suffix: '%',sortIndex:33},
        {label:'Review中差评',key:'midBadReview',sortIndex:34},
        {label:'Feedback中差评',key:'midBadFeedback',sortIndex:35},

        {label: "曝光量", key: "adsImpressions", sortIndex: 12 },
        {label: "点击量", key: "adsClicks", sortIndex: 13, default: true },
        {label: "CTR", key: "ctr",suffix: '%', sortIndex: 14 },
        {label: "广告花费", key: "adsSpend", sortIndex: 15, prefix: 'currencySymbol',default: true },
        {label: "CPC", key: "cpc", prefix: 'currencySymbol',sortIndex: 16 },
        {label: "广告订单量", key: "adsOrders", sortIndex: 17 },
        {label: "广告CVR", key: "cr", suffix: '%',sortIndex: 18, default: true },
        {label: "广告销售额", key: "adsSales",prefix: 'currencySymbol', sortIndex: 19 },
        {label: "ACOS", key: "acoS", suffix: '%',sortIndex: 20 },
        {label: "ACOAS", key: "acoAS", suffix: '%',sortIndex: 21 },
        {label: "ASOAS", key: "asoAS", suffix: '%',sortIndex: 22 },
        {label: "ROAS", key: "roAS", suffix: '%',sortIndex: 23 },
        {label: "总收入", key: "totalIncome", prefix: 'currencySymbol',sortIndex: 24 },
        {label: "总支出", key: "totalExpenditure", prefix: 'currencySymbol',sortIndex: 25 },
        {label: "销售毛利", key: "salesGrossProfit", prefix: 'currencySymbol',sortIndex: 26, default: true },
        {label: "销售毛利率", key: "grossProfitRate", suffix: '%',sortIndex: 27 , default: true},
        {label: "销售净毛利", key: "salesNetProfit", prefix: 'currencySymbol',sortIndex: 28 },
        {label: "销售净毛利率", key: "salesNetProfitRate", suffix: '%',sortIndex: 29 },
      ],
      settingMap: settingMap,
      debouncchangeDateType: this._.debounce(this.changeDateType, 100),
    }
  },
  created () {
    this.$gjQuery();
  },
  watch: {
    "currentSelect.key": {
      handler:function (val) {
        let hours = ['unitsOrdered', 'orderProductSales', 'orders']
        if (hours.includes(val)) {
          this.option.dateType = [
            {id: 'HOURS', text: '按时'},
            {id: 'DAY', text: '按日'},
            {id: 'WEEK', text: '按周'},
            {id: 'MONTH', text: '按月'},
          ]
        }else {
          this.option.dateType = [
            {id: 'DAY', text: '按日'},
            {id: 'WEEK', text: '按周'},
            {id: 'MONTH', text: '按月'},
          ];
          if (this.chartfilter.dateType == 'HOURS') {
            this.changeDateType('DAY')
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
    filter () {
      return this.getPageParams()
    },
    startDate() {
      let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[0], dateFormat) : null;
    },
    endDate() {
       let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[1], dateFormat) : null;
    },
    dateShortcut() {
      return dateShortcut(this.filter.date.key === 0?this.filter.date.value:'');
    },
    symbolAll() {
      let symbolAll = {
        prefix: [],
        suffix: []
      }
      for (const item of this.moduleColumns) {
        if (item.prefix) {
          symbolAll.prefix.push(item.key)
        }
        if (item.suffix) {
          symbolAll.suffix.push(item.key)
        }
      }
      return symbolAll
    },
  },
  mounted() {

  },
  methods:{
    /**
     * 获取首次加载所有数据
     */
    $gjQuery(){
      //获取概览自定义列
      this.getCustomColumns();
      //加载数据
      this.getOverviewAndPieData();
      this.getLineChartData();
    },
    /**
     * 加载自定义列
     */
    getCustomColumns(){
      getCustomColumns(this.settingName).then(res =>{
        let list = res ? res.split(",") : null;
        this.optionData = !_.isEmpty(list) ? this.moduleColumns.filter(e=> _.includes(list, e.key)) : this.moduleColumns.filter(e=> e.default);
        this.moduleColumns = !_.isEmpty(list) ? this.moduleColumns.map(e => {
          if (_.includes(list, e.key)){
            e.checked = true;
          }
          return e;
        }) : this.moduleColumns.map(e => {
          if (e.default){
            e.checked = true;
          }
          return e;
        })
      })
    },
    /**
     * 获取综合分析概览及饼图数据
     */
    getOverviewAndPieData(){
      const _this =this;
      this.loadingLeft = true;
      const activeOption = this.chartfilter.activeOption;
      let params = {
        ...this.filter,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
      }
      params = _.omit(params,["date","countryMarketValue","id","shortcutText","asinType","asinCode","activeOption"]);
      getOverviewAndPieData(params).then(res=>{
        let data = res;
        let comprehensiveAnalysisDetailVO = this.comprehensiveAnalysisDetailVO = data.comprehensiveAnalysisDetailVO;
        let comprehensiveAnalysisDetailVOThen = this.comprehensiveAnalysisDetailVOThen = data.comprehensiveAnalysisDetailVOThen;
        let comprehensiveAnalysisPieVO = this.comprehensiveAnalysisPieVO = data.comprehensiveAnalysisPieVO;
        //1、组装概览所需要的数据
        // test数据
        this.optionData = _.map(this.optionData, v=>{
          //若有值才向上取整，若无值则直接返回（否则null等情况会返回0）
          if(isMeaningless(comprehensiveAnalysisDetailVO[v.key])){
            v.value = comprehensiveAnalysisDetailVO[v.key]
          }else {
            v.value = _.ceil(comprehensiveAnalysisDetailVO[v.key], 2);
          }

          //环比是  （本期数据 - 上期数据） / 上期数据
          let chainRatio = _.floor(((_.toNumber(comprehensiveAnalysisDetailVO[v.key]) - _.toNumber(comprehensiveAnalysisDetailVOThen[v.key]))/comprehensiveAnalysisDetailVOThen[v.key]) *100);
          v.percent = chainRatio;
          v.checked = true;
          v.currencySymbol = comprehensiveAnalysisDetailVO['currencySymbol'];
          return v;
        });
        //2、组装饼图所需要的数据
        //计算总销量
        if (_.isEmpty(comprehensiveAnalysisPieVO)){
          _this.emptyPieData = true;
        } else {
          _this.cleanOverviewAndPieData(comprehensiveAnalysisPieVO);
        }
      }).complete(() =>{this.loadingLeft = false;})
    },
    /**
     * 清洗和组装饼图/折线图数据,并重新渲染
     */
    cleanOverviewAndPieData(comprehensiveAnalysisPieVO){
      const activeOption = this.chartfilter.activeOption;
      //2、组装饼图所需要的数据
      //计算总销量
      let totalOrdered = this.comprehensiveAnalysisDetailVO[activeOption];
      //选中 NRNF中差评  剔除相同的国家
      if(activeOption==='midBadReview'||activeOption==='midBadFeedback'){
        comprehensiveAnalysisPieVO = this._.uniqBy(comprehensiveAnalysisPieVO,'country');
      }
      comprehensiveAnalysisPieVO.map(v=>{
        // v.value = v.unitsOrdered;
        v.value = v[activeOption];
        if(isMeaningless(totalOrdered)){
          v.percent="-"
        }else if(totalOrdered==0){
          v.percent=0+"%"
        }else{
          v.percent = _.round(v[activeOption]/totalOrdered * 100) + "%"
        }
        let opt = _.find(this.marketOption, o=>o.id === parseInt(v.marketId));
        //选中 NRNF中差评  只按国家显示
        if(activeOption==='midBadReview'||activeOption==='midBadFeedback'){
          v.name = opt ? opt.countryCode : "";
        }else {
          v.name = opt ? opt.text : "";
        }
        return v;
      })
      //3、更新饼图
      this.emptyPieData = false;
      this.initComprehensiveAnalysisPieParams(comprehensiveAnalysisPieVO);
    },
    /**
     * 获取综合分析折线图数据
     */
    getLineChartData(){
      let params = {
        ...this.filter,
        ...this.chartfilter,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
      };
      params = _.omit(params,["date","countryMarketValue","id","shortcutText","asinType","asinCode","activeOption"]);
      this.loadingRight = true;
      getlineChartData(params).then((res) =>{
        let statisticsData = this.statisticsData = res.statisticsData;
        let thenData = this.thenData = res.thenData;
        // 1、组装折线图所需数据
        this.cleanLineChartData(statisticsData, thenData);
      }).complete(()=>{ this.loadingRight = false;});
    },
    cleanLineChartData(statisticsData =[], thenData=[]){
      let { dateType, activeOption,comparisonMethod,indexComparisonActives } = this.chartfilter;
      // 1、组装折线图所需数据
      let xAxisLine = [];        //折线图x轴坐标数组
      let lineSeriesData = [];   //折线图 series 数组
      let lineLegendData = [];
      // 1.1时间对比
      if(comparisonMethod === 0){ //按时间对比
        let listOne = [];          //本次数据
        let listTwo = [];          //对比数据
        for(let i=0;i<statisticsData.length;i++){
          xAxisLine.push(statisticsData[i].dateLine);
          listOne.push(statisticsData[i][this.chartfilter.activeOption]);
        }
        for(let i=0;i<thenData.length;i++){
          listTwo.push(thenData[i][this.chartfilter.activeOption]);
        }
        let itemOne = {
          name: '统计时间',
          type: 'line',
          stack: '总量',
          data: listOne
        };
        let itemTwo = {
          name: '对比时间',
          type: 'line',
          data: listTwo
        };
        lineSeriesData = _.concat(lineSeriesData, [itemOne, itemTwo]);
      } else {
        // 1.2指标对比
        let listX =[];
        for(let i=0;i<statisticsData.length;i++){
          xAxisLine.push(statisticsData[i].dateLine);
        }
        for(let i=0;i<indexComparisonActives.length;i++){
          lineLegendData.push(settingMap[indexComparisonActives[i]]);
          let itemX ={
            name: settingMap[indexComparisonActives[i]],
            type: 'line',
          };
          // 判断是否显示y轴
          if (this.symbolAll.suffix.includes(indexComparisonActives[i])) {
            itemX.yAxisIndex = 1
          }
          let currencySymbol = "";
          let simpleData = [];
          _.map(statisticsData, v=>{
            if(!currencySymbol){
              currencySymbol = v.currencySymbol;
            }
            simpleData.push(v[indexComparisonActives[i]]);
          });
          let columnItem = _.find(this.moduleColumns, v=>v.key === indexComparisonActives[i]);
          if(_.get(columnItem, 'prefix')){
            itemX.currencySymbol = currencySymbol;
          }
          if(_.get(columnItem, 'suffix')){
            itemX.suffix = columnItem.suffix;
          }
          itemX.data = simpleData;
          lineSeriesData.push(itemX);
        }
      }

      this.xAxisLine = xAxisLine;
      this.lineSeriesData = lineSeriesData;
      this.lineLegendData = lineLegendData;
      let leftList = lineSeriesData.filter(item => item.yAxisIndex != 1)
      let rightList = lineSeriesData.filter(item => item.yAxisIndex == 1)
      let leftNumber = leftList.reduce((arr ,item) => arr.concat(item.data), [])
      let rightNumber = rightList.reduce((arr ,item) => arr.concat(item.data), [])
      if (leftNumber.length != 0) {
        this.numberMinMax.Yleft.max = Math.max(...leftNumber)>0?Math.max(...leftNumber):100
        this.numberMinMax.Yleft.min = Math.min(...leftNumber)
        this.numberMinMax.Yleft.interval = (Math.abs(this.numberMinMax.Yleft.min) + Math.abs(this.numberMinMax.Yleft.max))/ 4
      }else {
        this.numberMinMax.Yleft.interval = 25;
        this.numberMinMax.Yleft.max = 100
        this.numberMinMax.Yleft.min = 0
      }
      if (rightNumber.length != 0) {
        this.numberMinMax.Yright.max = Math.max(...rightNumber)>0?Math.max(...rightNumber):100
        this.numberMinMax.Yright.min = Math.min(...rightNumber)
        this.numberMinMax.Yright.interval = (Math.abs(this.numberMinMax.Yright.min) + Math.abs(this.numberMinMax.Yright.max))/ 4
      }else {
        this.numberMinMax.Yright.max = null
        this.numberMinMax.Yright.min = null
      }
      this.initComprehensiveAnalysisLineParams(xAxisLine, lineSeriesData, lineLegendData, statisticsData, thenData);
    },
    /**
     * 切换概览项
     */
    selectOption(item){
      this.chartfilter.activeOption = item.key;
      this.chartfilter.indexComparisonActives =
              _.chain(_.concat(this.chartfilter.indexComparisonActives, [item.key])).uniq().value();
      this.currentSelect = item;
      this.cleanOverviewAndPieData(this.comprehensiveAnalysisPieVO);
      this.cleanLineChartData(this.statisticsData, this.thenData);
    },
    /**
     * 切换时间类型
     */
    changeDateType(value){
      this.chartfilter.dateType = value;
      this.getLineChartData();
    },
    /**
     * 刷新
     */
    refresh(params){
      this.$gjQuery()
    },
    /**
     * 下载
     */
    download(){
      this.templateDownloadLoading = true;
      const templateUrl = "/operation/storeOperation/comprehensive/export";
      const templateParams = {
        ...this.filter,
        ...this.chartfilter,
      };
      exportFile(templateUrl, templateParams)
          .complete(() => this.templateDownloadLoading = false);
    },
    /**
     * 打开设置弹窗
     */
    openCustomColumnModal(){
      const _this = this;
      this.$gjCreate('gj-setting-custom-modal', {
        props: {
          name: "ComprehensiveAnalysis",
          size: 'middle',
          moduleColumns: this.moduleColumns,
          allowNum: 8,
          customStr: "unitsOrdered,unitsOrderedB2b,orderProductSales,orderProductSalesB2b,orders,refunds,refundsRate," +
              "returnProductSales,returns,returnsRate,avgOrderItems,avgUnitsOrderedSales,adsImpressions,adsClicks,ctr,adsOrders," +
              "adsSales,cr,adsSpend,cpc,acoS,roAS,asoAS,acoAS,"+
              "totalIncome,totalExpenditure,salesGrossProfit,grossProfitRate,salesNetProfit,salesNetProfitRate"
        },
        on: {
          ["moduleColumns"](moduleColumns){
            _this.moduleColumns = moduleColumns;
            this.refresh()
          },
          ['check-list-items'](columns) {
            columns = _.map(columns, v=>{
              v.value = _.round(_this.comprehensiveAnalysisDetailVO[v.key], 2);
              //环比是  （本期数据 - 上期数据） / 上期数据
              let chainRatio = _.floor(((_.toNumber(_this.comprehensiveAnalysisDetailVO[v.key]) -
                  _.toNumber(_this.comprehensiveAnalysisDetailVOThen[v.key]))/_this.comprehensiveAnalysisDetailVOThen[v.key])*100);
              v.percent = chainRatio;
              v.currencySymbol = _this.comprehensiveAnalysisDetailVOThen['currencySymbol'];
              return v;
            });
            _this.optionData = columns;
          }
        }
      });
    },
    changeComparisonMethod(value){
      if(value === 0){
        this.chartfilter.indexComparisonActives = [];
      } else {
        this.chartfilter.indexComparisonActives =
            _.chain(_.concat(this.chartfilter.indexComparisonActives, [this.chartfilter.activeOption])).uniq().value();
      }
      this.isShowComparisonMethodSelect = value;
      this.cleanLineChartData(this.statisticsData, this.thenData);
    },
    changeIndexComparisonOptions(value){
      this.chartfilter.indexComparisonActives = value;
      //选择按时，只有三个指标
      this.cleanLineChartData(this.statisticsData, this.thenData, value);
    },
    initComprehensiveAnalysisPieParams(pieSeriesData){
      const option = {
        tooltip:{
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          align: 'auto',
          right: '0%',
          itemGap: 30 ,
          top: 'center',
          type: 'scroll',
          textStyle:{
            color: '#999',
            fontSize: 14,
          },
          formatter: (name,type) => {
            let item = _.find(pieSeriesData, v=> v.name ===name);
            let symbolS = this.symbolAll.prefix.includes(this.chartfilter.activeOption) ? _.get(item, 'currencySymbol', '') : ""
            let symbolE = this.symbolAll.suffix.includes(this.chartfilter.activeOption) ? "%" : ""
            let value = ""
            if (this.symbolAll.prefix.includes(this.chartfilter.activeOption)) {
              value = amount(_.get(item, this.chartfilter.activeOption, 0))
            }else {
              value = _.get(item, this.chartfilter.activeOption, 0)
            }
            return `${name || '-'}  ${value?symbolS+value+symbolE:'-'}    ${_.get(item, 'percent', '-')}`
          },
        },
        grid:{
          left: "0%",
          right: "0%"
        },
        icon: 'circle',
        color: ["#1F6EEF","#F6BD14","#FB6E6C","#9E87FF","#51D351","#F25AA0","#6060FC","#63E6C4","#A9FF74","#F7D857",
          "#A15DE6","#FF8D7D","#F5CF62","#82FA77","#6BDBFF","#59B2FF","#C340F5","#3CE658","#FA8955","#0FE7FA"],
        series: {
          type:  'pie',
          radius: ['40%', '60%'],
          center: ['25%', '50%'],
          label: {
            show: false,
            position: 'center',
            formatter: () =>{
              return settingMap[this.chartfilter.activeOption] + "    " + settingMap[this.chartfilter.activeOption];
            }
          },
          labelLine: {
            show: false
          },
          data: pieSeriesData,
          // data: [
          //   {
          //     type: 'pie',
          //     radius: ['40%', '60%'],
          //     center: ['25%', '50%'],
          //     avoidLabelOverlap: false,
          //     label: {
          //       show: false,
          //       position: 'center',
          //       formatter: (params) => {
          //         return [`{a|${settingMap[this.chartfilter.activeOption]}}`, `{b|${params.value}}`].join('\n')
          //       },
          //       rich: {
          //         a: {
          //           color: '#ccc',
          //           fontSize: 16,
          //           //用 lineHeight 加间距
          //           lineHeight: 26
          //         },
          //         b: {
          //           fontSize: 20,
          //         },
          //       }
          //     },
          //     emphasis: {
          //       label: {
          //         show: false,    //鼠标悬浮不显示
          //         fontSize: '20',
          //         fontWeight: 'bold',
          //         formatter: (params) => {
          //           return [`{a|${params.name}}`, `{b|${params.value}}`].join('\n')
          //         },
          //         rich: {
          //           a: {
          //             color: '#ccc',
          //             fontSize: 16,
          //             //用 lineHeight 加间距
          //             lineHeight: 26
          //           },
          //           b: {
          //             fontSize: 20,
          //           },
          //         }
          //       }
          //     },
          //     labelLine: {
          //       show: false
          //     },
          //     data: pieSeriesData
          //   }
          // ]
        }
      };

      this.comprehensiveAnalysisPieOption = option;
    },
    /**
     * 修改option变换图表
     */
    setOption(){

    },
    initComprehensiveAnalysisLineParams(xAxisLine, lineSeriesData, lineLegendData, statisticsData, thenData){
      let _this = this
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter:function(params){
            let str = '';
            params.map((v,idx)=>{
              let item = _.find(lineSeriesData, e=> e.name === v.seriesName);
              let currencySymbol = _.get(item,'currencySymbol');
              let suffix = _.get(item,'suffix');
              const dateLineIndex = statisticsData.findIndex(k => k.dateLine === v.name)
              const thenDateLine = dateLineIndex >= 0 ? thenData[dateLineIndex]['dateLine'] : v.name
              if(idx === 0){
                str += v.name + "<br/>";
              }
              let prefix1 = ""
              let suffix1 = ""
              if (['统计时间', '对比时间'].includes(v.seriesName)) {
                if (_this.symbolAll.prefix.includes(_this.chartfilter.activeOption)) {
                  prefix1 = _this.comprehensiveAnalysisDetailVO.currencySymbol
                }
                if (_this.symbolAll.suffix.includes(_this.chartfilter.activeOption)) {
                  suffix1 = "%"
                }
                str += v.marker + (v.seriesName === '统计时间' ? `统计时间：${v.name}&nbsp;&nbsp;&nbsp;` : `对比时间：${thenDateLine}&nbsp;&nbsp;&nbsp;`);
                str += `${prefix1}${amount(v.value)}${suffix1}` + "<br/>";
              }else {
                str += v.marker + v.seriesName + ":&nbsp;&nbsp;"
                if(v.value){
                if(currencySymbol){
                    str += currencySymbol + amount(v.value) + "<br/>";
                  } else {
                    if(suffix){
                      str += v.value + suffix + "<br/>";
                    } else {
                      str += v.value + "<br/>";
                    }
                  }
                } else {
                  str += "-<br/>"
                }
              }

            });
            return str;
          }
        },
        legend: {
          type:'scroll',
          data: !_.isEmpty(lineLegendData) ? lineLegendData : ["统计时间","对比时间"],
          top: '2%',
          itemGap: 10,
          icon: "rect",
          itemWidth: 15,
          itemHeight: 3,
          textStyle: {
            color: '#888',
            padding: [2, 0, 0, 0],
          }
        },
        grid: {
          // top: '28%',
          left: '50px',
          right: '75px',
          bottom: '8%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisLine,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#e5e9f2"
            }
          },
          axisLabel: {
            margin: 10,
            color: "#32393d"
          },
        },
        yAxis: [
          {
            axisLabel: {
              margin: 10,
              color: "#32393d",
              formatter:function (value) {
                if (String(value).includes(".")) {
                  return value.toFixed(2);
                }
                return value;
              }
            },
            type: 'value',
            splitNumber: 4,
            min: this.numberMinMax.Yleft.min,
            max: this.numberMinMax.Yleft.max,
            interval: this.numberMinMax.Yleft.interval,
            axisLine: {
              show: false,
              lineStyle: {
                color: "#e5e9f2"
              }
            },
          },
          {
            show: true,
            splitNumber: 4,
            min: this.numberMinMax.Yright.min,
            max: this.numberMinMax.Yright.max,
            interval: this.numberMinMax.Yright.interval,
            axisLabel: {
              margin: 10,
              formatter:function (value) {
                if (String(value).includes(".")) {
                  return `${value.toFixed(2)}%`;
                }
                return `${value}%`;
              },
              color: "#32393d"
            },
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: "#e5e9f2"
              }
            },
          }
        ],
        color: ["rgb(0, 153, 255)", "rgb(81, 211, 81)", '#F3667C','#46A1FF','#89D1EA','#4DCBCB','#85DFBE','#5ACB74','#ACDF84','#FAD54C','#FAF357','#EAA775'],
        series: lineSeriesData
      };
      this.comprehensiveAnalysisLineOption = option;
    }
  }
}
</script>

<style lang="scss" scoped>
 @import "../common/index.scss";
.comprehensive-analysis {

}
.el-card__body{
  height: 300px;
}
.gj-select {
  margin-right: 10px;
}
.el-radio-group{
  float: right;
}
.title-group{
  position: absolute;
  width: 10%;
  top: 45%;
  left: 6%;
  text-align: center;

  div{
    color: #999;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
  }
}
</style>
